import { rootUrl } from '@/constants';
import { getCookies } from '@/utils/cookie';
import axios from 'axios';

export type SubmitDeleteClient = {
  client: string;
};

export const deleteClient = async (data: SubmitDeleteClient) => {
  const response = await axios.delete(
    `${rootUrl}/psychologist/delete/clients`,
    {
      params: {
        client: data.client,
        token: getCookies('auth'),
      },
    }
  );

  return response.data;
};
